import { useLocale } from './locale';
import { translate, type MessageKey } from './messages';

/** Bileşenlerin tek metin kaynağı; anahtar TİPLİ (yazım hatası derlenmez). */
export function useTranslate(): (key: MessageKey, params?: Record<string, string | number>) => string {
  const locale = useLocale((state) => state.locale);

  return (key, params) => translate(locale, key, params);
}
